import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFastpassEmptyCart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 160,
	height: 160,
	fill: "none",
	viewBox: "0 0 160 160",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "M52.6284 125.006C56.3776 125.006 59.417 121.967 59.417 118.217C59.417 114.468 56.3776 111.429 52.6284 111.429C48.8792 111.429 45.8398 114.468 45.8398 118.217C45.8398 121.967 48.8792 125.006 52.6284 125.006Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "M100.925 128.32C104.675 128.32 107.714 125.281 107.714 121.532C107.714 117.783 104.675 114.743 100.925 114.743C97.1761 114.743 94.1367 117.783 94.1367 121.532C94.1367 125.281 97.1761 128.32 100.925 128.32Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "M42.0352 68.457L48.2177 105.028H116.995L125.464 68.457H42.0352Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D8DEE3",
			d: "M124.322 58.1484H128.322L117.053 104.526H113.533L124.322 58.1484Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D8DEE3",
			d: "M56.8461 127.132C59.9389 127.132 62.4461 124.624 62.4461 121.532C62.4461 118.439 59.9389 115.932 56.8461 115.932C53.7533 115.932 51.2461 118.439 51.2461 121.532C51.2461 124.624 53.7533 127.132 56.8461 127.132Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D8DEE3",
			d: "M102.596 127.132C105.689 127.132 108.196 124.624 108.196 121.532C108.196 118.439 105.689 115.932 102.596 115.932C99.5033 115.932 96.9961 118.439 96.9961 121.532C96.9961 124.624 99.5033 127.132 102.596 127.132Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M23.4531 28.5713H34.0817L50.916 114.468H100.927"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M101.361 57.8398H128.184L117.087 104.526H49.4414"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M62.3099 99.5201L57.8984 68.3887H115.704"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M83.5332 81.1768V98.7539"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M108.218 78.4111L103.658 99.4854"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M55.3715 128.593C59.2722 128.593 62.4343 125.431 62.4343 121.531C62.4343 117.63 59.2722 114.468 55.3715 114.468C51.4707 114.468 48.3086 117.63 48.3086 121.531C48.3086 125.431 51.4707 128.593 55.3715 128.593Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M100.926 128.593C104.827 128.593 107.989 125.431 107.989 121.531C107.989 117.63 104.827 114.468 100.926 114.468C97.0254 114.468 93.8633 117.63 93.8633 121.531C93.8633 125.431 97.0254 128.593 100.926 128.593Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.37143,
			d: "M50.8933 68.7539H41.9219"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CFD4DC",
			d: "M149.142 58.8056C151.49 58.8056 153.393 56.9022 153.393 54.5542C153.393 52.2062 151.49 50.3027 149.142 50.3027C146.794 50.3027 144.891 52.2062 144.891 54.5542C144.891 56.9022 146.794 58.8056 149.142 58.8056Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#CBD1DC",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.37143,
			d: "M120.891 34.1709V40.5252"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#CBD1DC",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.37143,
			d: "M13.2109 51.4463V57.8006"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#CBD1DC",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.37143,
			d: "M117.715 37.3486H124.081"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#CBD1DC",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.37143,
			d: "M10.0352 54.623H16.4009"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CFD4DC",
			d: "M20.3209 82.3029C21.5832 82.3029 22.6066 81.2795 22.6066 80.0172C22.6066 78.7548 21.5832 77.7314 20.3209 77.7314C19.0585 77.7314 18.0352 78.7548 18.0352 80.0172C18.0352 81.2795 19.0585 82.3029 20.3209 82.3029Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB5B5",
			d: "M66.1257 38.4223C67.2997 38.4223 68.2514 37.4706 68.2514 36.2966C68.2514 35.1226 67.2997 34.1709 66.1257 34.1709C64.9517 34.1709 64 35.1226 64 36.2966C64 37.4706 64.9517 38.4223 66.1257 38.4223Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB5B5",
			d: "M140.161 80.8403C141.335 80.8403 142.287 79.8886 142.287 78.7146C142.287 77.5406 141.335 76.5889 140.161 76.5889C138.987 76.5889 138.035 77.5406 138.035 78.7146C138.035 79.8886 138.987 80.8403 140.161 80.8403Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#778087",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.4,
			d: "M96.4 57.8398H40"
		})
	]
});
const ForwardRef = forwardRef(SvgFastpassEmptyCart);
export default ForwardRef;
